import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
FieldBuilder.setNamespace('General');

export const HOLIDAY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Holiday.Name')
    .required()
    .minLength(1)
    .maxLength(150)
    .build(),
];

export const HOLIDAY_CONFIG = {
  entityName: 'Holiday',
  localizationKey: 'General::Entity.Holiday',
  fields: HOLIDAY_FIELDS,
  permission: 'ControllingCalendar.Holidays',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Calendar + MENU_NAME_SUFFIX,
};
